import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M10.95 100.74H54.65C54.65 100.74 61.32 80.0299 61.67 44.9299C62.02 9.82993 59.21 1.57996 59.21 1.57996H7.60999C7.61999 1.56996 -8.00001 52.65 10.95 100.74Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
